import React from 'react';
import AppRouter from './Router';

export default function App() {
  document.title = 'FalconXcellence';

  return (
    <div>
      <AppRouter />
    </div>
  );
}
